import SearchIcon from '@material-ui/icons/Search';
import React from 'react'
import './SearchCatalog.css'
import {
  
  Checkbox,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Select,
} from "@material-ui/core";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PageTitle from '../global/PageTitle/PageTitle'
import InputBase from '@material-ui/core/InputBase';
import { Link } from 'react-router-dom'
export default function SearchCatalog() {
  return (
    <> 
<div className="catalog">
<PageTitle title="Search Catalog" />

<div className='catalog-header'>
    <div className='header-field'>
       <h4> Company</h4>
    <div className='h-f'>  LTFCORP Life Time, Inc </div> 

    </div>
    <div classNam='header-field'>
       <h4>Requester</h4>
    <div className='h-f'> Test Change (9003358)[C] </div> 

    </div>
    <div classNam='header-field'>
       <h4>Currency</h4>
    <div className='h-f'> USD</div> 

    </div>



</div>

    <div className='search'>
    <div className='search-icon'>
              <SearchIcon />
            <InputBase
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
            />
            </div>
            
            <button className='search-btn'>Search</button>
            </div></div>
<Link to='/cart'><ShoppingCartIcon/></Link>
            <div className='catalog-content'>
              <div className='catalog-sidebar'>
                <h2>Current Search</h2><br/>
              <button className='clear-all'>Clear All</button>
              <h2>Category</h2><br/>
              <h2>Supplier</h2><br/>
              <h2>Catalog</h2><br/>
              
              </div>
<div className='catalog-main'>   
<div className='catalog-search'>    
   <FormGroup>
              <FormControlLabel
                control={<Checkbox  />}
                label=""
              />
            </FormGroup>
    <h3>        48038 Results</h3>
   

            </div>  <hr/>
            <div className='catalog-search'>    
   <FormGroup>
              <FormControlLabel
                control={<Checkbox  />}
                label=""
              />
            </FormGroup>
            <div className='catalog-search-desc'>

    <h3 className='search-heading'>Utility Spring Snaps </h3>
    Ace Surfaces North America Inc | $0.81 | USD | Each| Repair-General Repair Parts & Labor (SC00142)
  </div>
    
            </div>   <hr/>
            <div className='catalog-search'>    
   <FormGroup>
              <FormControlLabel
                control={<Checkbox  />}
                label=""
              />
            </FormGroup>
            <div className='catalog-search-desc'>

    <h3 className='search-heading'>Utility Spring Snaps </h3>
    Ace Surfaces North America Inc | $0.81 | USD | Each| Repair-General Repair Parts & Labor (SC00142)
  </div>
    
            </div>   <hr/>
            <div className='catalog-search'>    
   <FormGroup>
              <FormControlLabel
                control={<Checkbox  />}
                label=""
              />
            </FormGroup>
            <div className='catalog-search-desc'>

    <h3 className='search-heading'>Utility Spring Snaps </h3>
    Ace Surfaces North America Inc | $0.81 | USD | Each| Repair-General Repair Parts & Labor (SC00142)
  </div>
    
            </div>   <hr/>
            <div className='catalog-search'>    
   <FormGroup>
              <FormControlLabel
                control={<Checkbox  />}
                label=""
              />
            </FormGroup>
            <div className='catalog-search-desc'>

    <h3 className='search-heading'>Utility Spring Snaps </h3>
    Ace Surfaces North America Inc | $0.81 | USD | Each| Repair-General Repair Parts & Labor (SC00142)
  </div>
    
            </div>   <hr/>
            </div> 
            </div>
            <div className='next-bar'>
    <button className='back-btn'>Add to Cart</button>
    <button className='next-btn'>Compare</button>
    
        </div>
        </>
  )
}

